var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"15","height":"2","viewBox":"0 0 15 2","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15 0V2H0V0H15Z","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }